
import * as actionTypes from '../actions/actionTypes'
const initState = {
  response: [],
  message: '',
}

export default (state = initState, action={}) => {
  switch (action.type) {
    case actionTypes.UNREAD_CHAT_REQUEST:
      return {
        ...state,
        response: [],
        message: '',      
      }   
    case actionTypes.UNREAD_CHAT_SUCCESS:
    
      return {
        ...state,
        response: action.payload.data,
        message: 'Success Data',      
      }   
    case actionTypes.UNREAD_CHAT_ERROR:
      return {
        ...state,
        response: [],
        message: 'Error',      
      }    

    case actionTypes.READ_CHAT_REQUEST:
      return {
        ...state,
        type:"",
        response: [],
        message: '',      
      }   
    case actionTypes.READ_CHAT_SUCCESS:
      return {
        ...state,
        type:"ChateReadStatus",
        response: action.payload.data,
        message: 'Success Data',      
      }   
    case actionTypes.READ_CHAT_ERROR:
      return {
        ...state,
        type:"",
        response: [],
        message: 'Error',      
      }    
    case actionTypes.CHAT_USER_LIST_REQUEST:
      return {
        ...state,
        type:"",
        response: [],
        message: '',      
      }   
    case actionTypes.CHAT_USER_LIST_SUCCESS:
    
      return {
        ...state,
        type:"ChatList",
        response: action.payload.data,
        message: 'Success Data',      
      }   
    case actionTypes.CHAT_USER_LIST_ERROR:
      return {
        ...state,
        type:"",
        response: [],
        message: 'Error',      
      }      
    case actionTypes.CHAT_USER_LIST_SEARCH_REQUEST:
      return {
        ...state,
        type:"",
        response: [],
        message: '',      
      }   
    case actionTypes.CHAT_USER_LIST_SEARCH_SUCCESS:
    
      return {
        ...state,
        type:"ChatListSearch",
        response: action.payload.data,
        message: 'Success Data',      
      }   
    case actionTypes.CHAT_USER_LIST_SEARCH_ERROR:
      return {
        ...state,
        type:"",
        response: [],
        message: 'Error',      
      }    
    case actionTypes.GET_COMPANY_CHAT_REQUEST:
      return {
        ...state,
        type:"",
        response: [],
        message: '',      
      }   
    case actionTypes.GET_COMPANY_CHAT_SUCCESS:
    
      return {
        ...state,
        type:"ChatList",
        response: action.payload.data,
        message: 'Success Data',      
      }   
    case actionTypes.GET_COMPANY_CHAT_ERROR:
      return {
        ...state,
        type:"",
        response: [],
        message: 'Error',      
      }    
    case actionTypes.FORWARD_CHAT_REQUEST:
      return {
        ...state,
        response: [],
        message: '',      
      }   
    case actionTypes.FORWARD_CHAT_SUCCESS:
    
      return {
        ...state,
        response: action.payload.data,
        message: 'Success Data',      
      }   
    case actionTypes.FORWARD_CHAT_ERROR:
      return {
        ...state,
        response: [],
        message: 'Error',      
      }    
    case actionTypes.GET_LIST_CHAT_REQUEST:
      return {
        ...state,
        type:"",
        response: [],
        message: '',      
      }   
    case actionTypes.GET_LIST_CHAT_SUCCESS:
    
      return {
        ...state,
        type:"chatHistory",
        response: action.payload.data,
        message: 'Success Data',      
      }   
    case actionTypes.GET_LIST_CHAT_ERROR:
      return {
        ...state,
        type:"",
        response: [],
        message: 'Error',      
      }    

    case actionTypes.BLOCK_USER_CHAT_REQUEST:
      return {
        ...state,
        type:"",
        response: [],
        message: '',      
      }   
    case actionTypes.BLOCK_USER_CHAT_SUCCESS:
    
      return {
        ...state,
        type:"blockUser",
        response: action.payload.data,
        message: 'Success Data',      
      }   
    case actionTypes.BLOCK_USER_CHAT_ERROR:
      return {
        ...state,
        type:"",
        response: [],
        message: 'Error',      
      }    

    case actionTypes.UNBLOCK_USER_CHAT_REQUEST:
      return {
        ...state,
        type:"",
        response: [],
        message: '',      
      }   
    case actionTypes.UNBLOCK_USER_CHAT_SUCCESS:
    
      return {
        ...state,
        type:"UnblockUser",
        response: action.payload.data,
        message: 'Success Data',      
      }   
    case actionTypes.UNBLOCK_USER_CHAT_ERROR:
      return {
        ...state,
        type:"",
        response: [],
        message: 'Error',      
      }    
    default:
      return state
  }
}




// WEBPACK FOOTER //
// ./src/reducers/Chat.js